import { NgModule } from '@angular/core';

import { FilterPipe, LIB_CommonModule, SearchPipe, SorterPipe } from 'pbc.angular';

import { BerichtsVorlagenService } from '.';

@NgModule({
  imports: [LIB_CommonModule],
  providers: [BerichtsVorlagenService, SearchPipe, FilterPipe, SorterPipe],
  exports: [],
})
export class BerichtsVorlagenServiceModule {}
